// PLIK GENEROWANY - nie edytuj ręcznie.
// Generator: scripts/przystanie/gen.py, 2026-07-28 21:30
// Źródło danych: OpenStreetMap (© współtwórcy OSM, licencja ODbL)
//   + odwrotne geokodowanie Nominatim.
// Klucze skrócone, żeby plik nie puchł: n=nazwa, a=adres, c=miejscowość,
// p=powiat, r=slug województwa, rw=nazwa województwa, t=telefon, w=www,
// f=facebook, e=e-mail, h=godziny, m=miejsca postojowe, d=opis,
// s=punktacja kompletności danych, k=spełnione kryteria.

// Teksty wprowadzające podstron obszarów. Puste, dopóki nie powstaną
// unikalne opisy w scripts/przystanie/teksty-wojewodztwa.json.

export const PRZYSTANIE_COPY = {};
